import React from 'react';
import { Container, Row, Col, Form, Button, Card, Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic, faCopy, faDownload, faRedo, faPen } from '@fortawesome/free-solid-svg-icons';
import '../components/components.css';

const LyricsAi = () => {
  return (
    <Container className="py-4 beats-component-container">
      <h2 className="mb-4">Lyrics AI Generator</h2>
      
      <Tabs defaultActiveKey="generate" className="mb-4 beats-tabs">
        <Tab eventKey="generate" title="Generate Lyrics">
          <Card className="beats-card">
            <Card.Body>
              <Form>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="beats-form-label">Theme / Topic</Form.Label>
                      <Form.Control type="text" placeholder="Love, heartbreak, success, etc." className="beats-form-control" />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="beats-form-label">Genre</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Hip Hop / Rap</option>
                        <option>Pop</option>
                        <option>R&B</option>
                        <option>Rock</option>
                        <option>EDM</option>
                        <option>Country</option>
                        <option>Folk</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="beats-form-label">Mood</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Upbeat / Happy</option>
                        <option>Sad / Melancholic</option>
                        <option>Angry / Intense</option>
                        <option>Hopeful / Inspirational</option>
                        <option>Chill / Relaxed</option>
                        <option>Party / Energetic</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="beats-form-label">Structure</Form.Label>
                      <Form.Select className="beats-form-select">
                        <option>Verse-Chorus-Verse-Chorus-Bridge-Chorus</option>
                        <option>Verse-Chorus-Verse-Chorus</option>
                        <option>Verse Only</option>
                        <option>Chorus Only</option>
                        <option>16 Bars (Rap Verse)</option>
                        <option>Freestyle</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                
                <Form.Group className="mb-3">
                  <Form.Label className="beats-form-label">Seed Lyrics (Optional)</Form.Label>
                  <Form.Control as="textarea" rows={3} placeholder="Add some starting lyrics or key phrases..." className="beats-form-control" />
                  <Form.Text className="beats-form-text">
                    Add some starting lines to guide the AI in the right direction
                  </Form.Text>
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label className="beats-form-label">Writing Style Inspiration (Optional)</Form.Label>
                  <Form.Control type="text" placeholder="Drake, Taylor Swift, Kendrick Lamar, etc." className="beats-form-control" />
                </Form.Group>
                
                <div className="d-grid mt-4">
                  <Button variant="primary" size="lg" className="beats-btn-primary">
                    <FontAwesomeIcon icon={faMagic} className="me-2" />
                    Generate Lyrics
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Tab>
        
        <Tab eventKey="results" title="Generated Results">
          <Card className="beats-card">
            <Card.Body>
              <div className="d-flex justify-content-between mb-3">
                <h4>Generated Lyrics</h4>
                <div>
                  <Button variant="outline-secondary" className="me-2 beats-btn-outline">
                    <FontAwesomeIcon icon={faCopy} className="me-1" />
                    Copy
                  </Button>
                  <Button variant="outline-secondary" className="me-2 beats-btn-outline">
                    <FontAwesomeIcon icon={faDownload} className="me-1" />
                    Download
                  </Button>
                  <Button variant="outline-primary" className="beats-btn-outline">
                    <FontAwesomeIcon icon={faRedo} className="me-1" />
                    Regenerate
                  </Button>
                </div>
              </div>
              
              <Card className="bg-dark mb-4">
                <Card.Body>
                  <div className="mb-3">
                    <small className="text-secondary beats-form-text">[Verse 1]</small>
                  </div>
                  <p>
                    Lost in the echo of my thoughts tonight<br />
                    Searching for answers in the pale moonlight<br />
                    Every step forward feels like two steps back<br />
                    Memories fade like footprints in the sand
                  </p>
                  
                  <div className="mb-3">
                    <small className="text-secondary beats-form-text">[Chorus]</small>
                  </div>
                  <p>
                    When the waves come crashing down<br />
                    Will you still be around?<br />
                    When the lights all fade to black<br />
                    Will you find your way back?<br />
                    When the world seems cold and strange<br />
                    Will your heart remain unchanged?
                  </p>
                  
                  <div className="mb-3">
                    <small className="text-secondary beats-form-text">[Verse 2]</small>
                  </div>
                  <p>
                    Whispers of doubt crawl under my skin<br />
                    Fighting these battles I can't seem to win<br />
                    Building walls up just to tear them down<br />
                    Drowning in silence but afraid to drown
                  </p>
                </Card.Body>
              </Card>
              
              <Form.Group className="mb-3">
                <Form.Label className="beats-form-label">Edit Lyrics</Form.Label>
                <Form.Control as="textarea" rows={10} className="beats-form-control" defaultValue={`[Verse 1]
Lost in the echo of my thoughts tonight
Searching for answers in the pale moonlight
Every step forward feels like two steps back
Memories fade like footprints in the sand

[Chorus]
When the waves come crashing down
Will you still be around?
When the lights all fade to black
Will you find your way back?
When the world seems cold and strange
Will your heart remain unchanged?

[Verse 2]
Whispers of doubt crawl under my skin
Fighting these battles I can't seem to win
Building walls up just to tear them down
Drowning in silence but afraid to drown`} />
              </Form.Group>
              
              <Button variant="primary" className="beats-btn-primary">
                <FontAwesomeIcon icon={faPen} className="me-2" />
                Save Edits
              </Button>
            </Card.Body>
          </Card>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default LyricsAi; 